// Types
import type { IVDropdownOption } from '~/misc/v-dropdown/types';
import type { TDashboardPeriod } from '~/modules/opportunities/automated-email/dashboard/types';

const DASHBOARD_PERIOD_OPTIONS: IVDropdownOption<string, TDashboardPeriod>[] = [
  { label: 'Last 30 days', value: 30 },
  { label: 'Last 60 days', value: 60 },
  { label: 'Last 90 days', value: 90 },
];

const DEFAULT_PERIOD: TDashboardPeriod = 30;

export { DASHBOARD_PERIOD_OPTIONS, DEFAULT_PERIOD };
